import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

interface AlertBoxProps {
  icon?: ReactNode;
  title?: string;
  message: string;
  textColor?: string;
  bgColor?: string;
  visibleClose?: boolean;
  className?: string;
}

export const Toast = ({
  icon = <Info />,
  title = '',
  message = '',
  textColor = '#4b5563',
  bgColor = '#FF9800',
  visibleClose = true,
  className = '',
}: AlertBoxProps) => {
  return (
    <div
      className={twMerge('flex w-full items-center p-4 border border-[#FF9800] rounded-sm dark:text-white-400', className)}
      id="alert-1"
      role="alert"
      style={{
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      <div>{icon}</div>
      <div className="ms-3 text-gray-400 flex flex-col px-2">
        <p>{title}</p>
        <p>{message}</p>
      </div>
      {visibleClose && (
        <button aria-label="Close" className="right-2 ms-auto -mx-1.5 -my-1.5 text-gray-900" data-dismiss-target="#alert-1" type="button">
          <span className="sr-only">Close</span>
          <svg aria-hidden="true" className="w-3 h-3" fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </button>
      )}
    </div>
  );
};
